module.exports = __webpack_public_path__ + "img/pwr_on2.1d7917cf.png";